export default __webpack_public_path__ + "b76ccad2aeb92969102cb6ace93255ff.png";